import initialState from './initialState';
import {reducer as feddsReducer} from './fetchFeeds';
const reducers = [
    feddsReducer
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/homepage/redux/reducer.js